import React from 'react';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';
import SubscriptionManager from '../components/subscription/SubscriptionManager';
import { useAuth } from '../contexts/AuthContext';

const Container = styled.div`
  min-height: calc(100vh - 200px);
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
`;

const Subscription = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Container>
      <SubscriptionManager />
    </Container>
  );
};

export default Subscription;